import _ from "lodash";
import React, { createRef } from "react";
import classes from "./ImageViewerV2.scss";
// import "react-viewer/dist/index.css";
import PropTypes from "prop-types";
import { TransformComponent, TransformWrapper } from "react-zoom-pan-pinch";

class ImageViewerV2 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      imageRotation: 0,
      imageDimensions: { width: 0, height: 0 },
    };
    this.viewerRef = createRef();
    this.transformerRef = createRef();
  }

  rotate = () => {
    this.setState({ imageRotation: this.state.imageRotation + 90 });
  };

  fitToSpace = () => {
    const { attachment = {} } = this.props;
    const imageDimensions = this.getImgWidthHeight(
      _.get(attachment, "metadata.width", 1080),
      _.get(attachment, "metadata.height", 680)
    );
    this.setState({
      imageDimensions: {
        width: imageDimensions?.width,
        height: imageDimensions?.height,
      },
    });
    if (this.transformerRef) {
      this.transformerRef?.centerView(1);
    }
  };
  initRef = ref => {
    this.transformerRef = ref;
    const { getRef = {} } = this.props;
    if (ref != null) {
      ref.rotate = this.rotate;
      ref.fitToSpace = this.fitToSpace;
      if (_.isFunction(getRef)) getRef(ref);
    }
  };

  componentDidMount() {
    this.fitToSpace();
  }

  getImgWidthHeight = (imgWidth, imgHeight) => {
    let width = 0;
    let height = 0;
    let maxWidth = 0,
      maxHeight = 0;
    if (!_.isNil(this.viewerRef?.current)) {
      maxWidth = _.get(this.viewerRef.current, "clientWidth", 1080);
      maxHeight = _.get(this.viewerRef.current, "clientHeight", 680) - 24;
    } else {
      maxWidth = 1080;
      maxHeight = 680;
    }
    width = Math.min(maxWidth, imgWidth);
    height = (width / imgWidth) * imgHeight;
    if (height > maxHeight) {
      height = maxHeight;
      width = (height / imgHeight) * imgWidth;
    }

    return { width, height };
  };
  render() {
    const { attachment, imageContainerStyles } = this.props;
    const imageViewStyle = {
      backgroundImage: `url('${_.get(attachment, "url")}')`,
      transform: `rotate(${_.get(this.state, "imageRotation", 0)}deg)`,
    };
    return (
      <div className={classes.container}>
        <div
          className={classes.imageContainer}
          ref={this.viewerRef}
          style={imageContainerStyles}
        >
          <TransformWrapper
            wheel={{ step: 0.08 }}
            velocityAnimation={{ velocity: 125 }}
            limitToBounds={true}
            ref={this.initRef}
            centerOnInit={true}
          >
            <TransformComponent
              wrapperStyle={{ width: "100%", height: "100%" }}
              contentStyle={{ width: "100%", height: "100%" }}
            >
              <div className={classes.imageView} style={imageViewStyle} />
            </TransformComponent>
          </TransformWrapper>
        </div>
      </div>
    );
  }
}

ImageViewerV2.propTypes = {
  attachment: PropTypes.object,
  imageContainerStyles: PropTypes.object,
};

ImageViewerV2.defaultProps = {
  attachment: {},
  imageContainerStyles: {},
};

export default ImageViewerV2;
